/** @jsx jsx */
import React, { useMemo, useState } from 'react'
import { useSpring } from 'react-spring'
import { useHarmonicIntervalFn } from 'react-use'
import { Box, jsx } from 'theme-ui'
import { AnimatedPositioned } from '../../components/Positioned'
import { ClientGameHandController } from '../../controllers/ClientGameHandController'
import { theme } from '../../gatsby-plugin-theme-ui/theme'
import { IPositioningMeasurements, IPositionProps, IUserPositioning } from './positionProps'

interface ICurrentActionButtonProps extends IPositionProps {
  controller: ClientGameHandController
}

const calculatePosition = (position: IUserPositioning) => {
  return position.calcPositionFromPixels(-25)
}

const useMockCurrentActionButtonPositionAnimation = ({
  currentUserTablePositioning,
  otherUserPositioning,
  measurements,
  controller,
}: ICurrentActionButtonProps) => {
  const [dealerIndex, setDealerIndex] = useState(0)
  const userPositioning = [...otherUserPositioning, currentUserTablePositioning]
  const position = userPositioning[dealerIndex]
  const isLastUser = dealerIndex === userPositioning.length - 1
  useHarmonicIntervalFn(() => {
    setDealerIndex(isLastUser ? 0 : dealerIndex + 1)
  }, 3000)
  return calculatePosition(position)
}

const useCurrentActionButtonPosition = ({
  measurements,
  controller,
}: ICurrentActionButtonProps) => {
  return useMemo(() => {
    const position = controller.getUserData(controller.gameHand.nextUserIdToAct)
    return calculatePosition(position)
  }, [controller.gameHand.nextUserIdToAct, measurements.windowWidth, measurements.windowHeight])
}

export const CurrentActionButton: React.FC<ICurrentActionButtonProps> = (props) => {
  const position = useCurrentActionButtonPosition(props)
  const { left, top } = useSpring({
    left: position.left,
    top: position.top,
  })

  return (
    <AnimatedPositioned
      width={props.measurements.isLandscapeMode ? 50 : 20}
      height={20}
      coords={{ left, top }}
    >
      <Box
        sx={{
          bg: 'lightGreen',
          height: '100%',
          borderRadius: 'pill',
          textAlign: 'center',
          lineHeight: '1',
          color: 'white',
          fontSize: 0,
          py: 2,
          boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.15)',
          textShadow: `1px 1px 6px rgba(0,0,0,.4)`,
          zIndex: 1,
        }}
      >
        {props.measurements.isLandscapeMode ? 'Action' : 'A'}
      </Box>
    </AnimatedPositioned>
  )
}
